import { ProductImages } from './Product'

export const LegacyProductFallbackImage = '/images/product-img-fallback.png'
export const ProductFallbackImage = '/images/wc-placeholder-img.jpg'

export const StandardImgSizes = [256, 640, 1280, 2560] as const
export type ImgSize = (typeof StandardImgSizes)[number]

export interface ImgApiResponse extends ProductImages {
  success: boolean
}

export type StorageDirectory = 'presentations' // | 'tempProductImages'
